// @core/api/endpoints/chat/update_chat_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChatPolicyResponse,
  UpdateChatPolicyRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Update chat policy
 * Updates an existing chat policy.
 */
export async function UpdateChatPolicy(
  policy_id: string,
  data: UpdateChatPolicyRequest,
  options?: RequestOptions
): Promise<ChatPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/chat-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<ChatPolicyResponse>(requestPath, data, requestOptions);
}
